const destinationBankAccountStatus = {
  CREATED: 'CRIADO',
  PENDING_VERIFICATION: 'PENDENTE_VERIFICACAO',
  DATA_VALIDATED: 'DADOS_VALIDADOS',
  VERIFIED: 'VERIFICADO',
  FAILED: 'FALHA',
  REMOVED: 'REMOVIDO'
};

module.exports = destinationBankAccountStatus;
